import React from 'react'
import Pt from 'prop-types'
import { Panel } from 'react-bootstrap'

import Icon from 'internal-components/src/components/Icon'
import { SignupWithExternalsRecord } from 'internal-components/src/records'

export default function Qualification({ signupWithExternals }) {
  return (
    <Panel bsStyle="warning" style={{ borderLeftWidth: '3px' }}>
      <Panel.Body>
        <h4 style={{ color: '#8a6d3b' }}>
          <Icon name="warning" /> Service Qualification and Installation
        </h4>

        <p>
          Your selected service type requires installation. We will conduct a
          service qualification on your address to ensure we can provide this
          service reliably. Once this has occurred we will proceed with the
          order and notify you when an installation date is set. If the service
          qualification fails we will contact you to discuss possible
          alternatives.
        </p>

        <p>
          You can keep an eye out for the installation date by returning to{' '}
          <a href="https://signup.infinite.net.au">
            https://signup.infinite.net.au
          </a>{' '}
          or checking your emails.
        </p>

        <p>
          If you have any queries regarding the installation of this service
          please contact us during business hours on 1300 790 337 or email{' '}
          <a href="mailto:support@infinite.net.au">support@infinite.net.au</a>{' '}
          with the reference{' '}
          <strong>{signupWithExternals.signup.get('reference')}</strong>.
        </p>
      </Panel.Body>
    </Panel>
  )
}

Qualification.propTypes = {
  signupWithExternals: Pt.instanceOf(SignupWithExternalsRecord).isRequired,
}



// WEBPACK FOOTER //
// ./src/components/SignupDetails/Qualification.jsx